import cx from 'classnames';
import styles from './FeatureItem.module.scss';
import { icons } from '../../assets';
const { CheckIcon } = icons;

export default function FeatureItem({
  as,
  style = {},
  title,
  titleStyle = {},
  description,
  descriptionStyle = {},
  icon = CheckIcon,
  theme = 'light', // dark
  designType, // v2. If designType is null then we are using the old design
}) {
  const Component = as || 'li';
  const Icon = icon;

  if (!title) return null;

  if (designType === 'v2') {
    return (
      <Component className={cx(styles.v2, styles[theme])} style={style}>
        <div className={styles.icon}>
          <Icon />
        </div>
        <h2 className={styles.title} style={titleStyle}>
          {title}
        </h2>
        <p className={styles.description} style={descriptionStyle}>
          {description}
        </p>
      </Component>
    );
  }

  return (
    <Component className={cx(styles.v1, styles[theme])} style={style}>
      <Icon className={styles.icon} style={{ color: 'var(--primary-color)' }} />
      <p className={styles.title} style={titleStyle}>
        {title}
      </p>
    </Component>
  );
}
